<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">会员</a></el-breadcrumb-item>
          <el-breadcrumb-item>会员卡</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="memberCard" label-width="160px" size="medium" >
        <el-form-item label="会员卡名称">
          <el-col :span="12">
            <el-input v-model="memberCard.name" ></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="售卡金额">
          <el-col :span="12">
            <el-input placeholder="请输入售卡金额" v-model="memberCard.soldMoney">
              <template slot="append">元</template>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="有效期">
          <el-col :span="12">
            <el-input placeholder="请输入有效期" v-model="memberCard.validityDays">
              <template slot="append">天</template>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="赠送积分">
          <el-col :span="12">
            <el-input placeholder="请输入积分" v-model="memberCard.point">
              <template slot="append">分</template>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="赠送鼓励金">
          <el-col :span="12">
            <el-input placeholder="请输入鼓励金" v-model="memberCard.reward">
              <template slot="append">元</template>
            </el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="分享描述">
          <el-col :span="12">
            <el-input type="textarea" v-model="memberCard.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <editor @showEditor="updateDescription" :content="memberCard.description"></editor>
        </el-form-item>
        <el-form-item >
          <el-col :span="12">
            <el-button type="primary" @click="SaveFlashSale">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import editor from '@/components/wang-editor';
  export default {
    props:{
    },
    data (){
      return {
        memberCard:{},
      }
    },
    computed:{
      imagesList:function(){
        var result= [];
        if(this.chainStore.images!=undefined){
          var images = this.chainStore.images.split(',');
          images.forEach(element => {            
            let o=  {
              url:element
            }
            //o.url=element
            result.push(o)
          });
        }        
        return result;
      }
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/MemberCard/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.memberCard = resp.data.result.memberCard
      })
    },
    methods:{     
      SaveFlashSale:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/MemberCard/Save',         
          data:that.memberCard
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      updateDescription(data){
        this.memberCard.description=data
      },
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'memberCard',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{
      editor
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>